import { useEffect, useState } from "react";
import { GET_ALL_BLOG, GET_HOMEPAGE_BLOG, fetchData } from "../../../components/Service";
import moment from "../../../../node_modules/moment/moment";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";

const Blogs = () => {
	const [blogs, setBlogs] = useState([]);

	const getBlogs = () => {
		fetchData(GET_ALL_BLOG, "GET", "", false, false, (res) => {
			if (res.status) {
				setBlogs(res?.data?.data);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		getBlogs();
	}, []);
	return (
		<>
			{blogs && blogs.length > 0 && (
				<div class="card">
					<div class="card-header d-flex align-items-center justify-content-between mb-0 usa-bg py-1">
						<div className="national-bg">
							<h6 class="text-white d-flex ind1">Blogs</h6>
						</div>
						<Link to={`blogs`} class="text-white align-middle font13 d-flex align-items-center position-relative ">
							View <i class="fi fi-rr-arrow-small-right text-white linehight0 ms-1"></i>
						</Link>
					</div>
					<div className="card-body p-1">
						<div class="row d-flex align-items-center">
							{blogs?.slice(0, 3)?.map((item) => (
								<div key={item.id} class="col-sm-4 ">
									<Link to={`blogs/${item.id}`} className="card blog-card">
										<div className="card-body py-2 px-2">
											<h6 className="text-white fw-normal mt-0 blogtitle">{item.title}</h6>
											<p className="text-white mb-0 font11 blogdiscription ">{item.description}</p>
											<p>
												<span class="text-white font11">
													<i class="fi fi-rs-calendar me-1 font11"></i> {item.created_at ? moment(item.created_at).format("DD-MMM-YYYY") : ""}
												</span>
											</p>
										</div>
									</Link>
								</div>
							))}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default Blogs;
